import { Switch } from '../../../../../ui/components/ui/switch';
import { releaseStatusOf } from '../../constants/release-status';

export interface ReleaseSwitchProps {
  isReleased: boolean;
  onChange: (nextIsReleased: boolean) => void;
  /** Blocks releasing — the server rejects a course without lessons. */
  canRelease?: boolean;
  isBusy?: boolean;
}

/**
 * Status and control in one element: the label and lamp state what the course is, the switch changes it.
 * Colours come from the same tokens as ReleaseBadge, so list and builder always agree.
 */
const ReleaseSwitch = ({ isReleased, onChange, canRelease = true, isBusy }: ReleaseSwitchProps) => {
  const status = releaseStatusOf(isReleased);
  const isBlocked = !canRelease && !isReleased;

  return (
    <label
      className={`flex items-center gap-2.5 text-[13px] font-semibold ${status.text} ${isBlocked ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      title={isBlocked ? 'Der Kurs braucht mindestens eine Lektion.' : undefined}>
      <span className={`w-[7px] h-[7px] rounded-full shrink-0 ${status.lamp}`} />
      {status.label}
      <Switch checked={isReleased} onCheckedChange={onChange} disabled={isBlocked || isBusy} aria-label="Kurs veröffentlichen" />
    </label>
  );
};

export default ReleaseSwitch;
